import { render } from "./Completed.vue?vue&type=template&id=065351fa"
import script from "./Completed.vue?vue&type=script&lang=js"
export * from "./Completed.vue?vue&type=script&lang=js"
script.render = render

export default script